(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["founding-circle-v1"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    function init() {
      // Reveal animations
      document.querySelectorAll('.fc-v1 .reveal').forEach(function(el) {
        if (el.dataset.fcObserved) return;
        el.dataset.fcObserved = '1';
        observer.observe(el);
      });

      // Hero video: ensure autoplay on iOS / restart on section reload
      document.querySelectorAll('.fc-v1 .fc-hero__video').forEach(function(v) {
        if (v.dataset.fcInit) return;
        v.dataset.fcInit = '1';
        // Some browsers need an explicit play() call after DOM ready
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function() { /* autoplay blocked, poster will show */ });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founding-circle-v2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    function init() {
      document.querySelectorAll('.fc-v2 .reveal').forEach(function(el) {
        if (el.dataset.fcObserved) return;
        el.dataset.fcObserved = '1';
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founding-circle-v3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    function init() {
      document.querySelectorAll('.fc-v3 .reveal').forEach(function(el) {
        if (el.dataset.fcObserved) return;
        el.dataset.fcObserved = '1';
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seasonal-pillar"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.jp-root');
  roots.forEach(function(root){
    if (root.__jpInit) return;
    root.__jpInit = true;

    var sel = root.getAttribute('data-modal');
    var modal = sel ? document.querySelector(sel) : null;

    function open(){
      if (!modal) return;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var f = modal.querySelector('a, button');
      if (f) f.focus();
    }
    function close(){
      if (!modal) return;
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    root.querySelectorAll('[data-locked="true"]').forEach(function(card){
      card.addEventListener('click', open);
      card.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });

    if (modal){
      modal.querySelectorAll('[data-close]').forEach(function(el){
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    }

    /* ---------- Notify Me (subscribers) ---------- */
    var custId = root.getAttribute('data-customer-id') || '';
    var storeKey = custId ? 'jp-notified-v2-' + custId : '';

    function readStored() {
      if (!storeKey) return [];
      try { return JSON.parse(localStorage.getItem(storeKey) || '[]'); } catch (e) { return []; }
    }
    function saveStored(tags) {
      if (!storeKey) return;
      try { localStorage.setItem(storeKey, JSON.stringify(tags)); } catch (e) { /* no-op */ }
    }
    function markDone(tag) {
      var esc = (window.CSS && CSS.escape) ? CSS.escape(tag) : tag;
      root.querySelectorAll('[data-jp-notify][data-tag="' + esc + '"]').forEach(function (btn) {
        var done = document.createElement('div');
        done.className = 'jp-notify jp-notify--done';
        done.textContent = root.getAttribute('data-done-label') || "You're on the list";
        var form = btn.closest('form');
        (form || btn).replaceWith(done);
      });
    }

    var stored = readStored();

    /* a customer form just posted -> ?jp_notified=TAG names which drop */
    try {
      var params = new URLSearchParams(window.location.search);
      var doneTag = params.get('jp_notified');
      if (doneTag && stored.indexOf(doneTag) === -1) {
        stored.push(doneTag);
      }
      /* drop the query so a refresh doesn't repeat this */
      if (doneTag && window.history && history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.hash);
      }
    } catch (err) { /* no-op */ }

    saveStored(stored);

    /* requested before on this device -> show the done state */
    stored.forEach(markDone);

    /* ---------- Auto-tag mode (Cloudflare Worker endpoint) ---------- */
    var apiUrl = root.getAttribute('data-notify-endpoint') || '';
    var apiSig = root.getAttribute('data-notify-sig') || '';

    root.querySelectorAll('[data-jp-notify-api]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!apiUrl || !apiSig || !custId) return;
        var tag = btn.getAttribute('data-tag');
        var span = btn.querySelector('span');
        var original = span ? span.textContent : '';
        btn.disabled = true;
        if (span) span.textContent = 'Adding you\u2026';
        fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ customer_id: custId, tag: tag, sig: apiSig })
        })
          .then(function (r) { if (!r.ok) { throw new Error('failed'); } return r.json(); })
          .then(function () {
            if (stored.indexOf(tag) === -1) { stored.push(tag); saveStored(stored); }
            markDone(tag);
          })
          .catch(function () {
            btn.disabled = false;
            if (span) span.textContent = original;
          });
      });
    });

    root.querySelectorAll('form.jp-notify-form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-jp-notify]');
        if (!btn) return;
        var span = btn.querySelector('span');
        var original = span ? span.textContent : '';
        /* defer, so the native submission always dispatches first */
        setTimeout(function () {
          btn.disabled = true;
          if (span) span.textContent = 'Adding you\u2026';
        }, 0);
        /* watchdog: restore the button if the page hasn't navigated after 8s */
        setTimeout(function () {
          btn.disabled = false;
          if (span) span.textContent = original;
        }, 8000);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.split-feature__content-inner');
    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    sections.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
